<template>
  <div class="container flex flex-col justify-center">
    <h1 class="heading-1 py-2 text-center">{{ $t('error.title') }}</h1>
    <p class="text-center">{{ $t('error.content') }}</p>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class ErrorView extends Vue {}
</script>
